module.exports = __webpack_public_path__ + "static/spinnin-2ab0122eeed9e956bbcde9e4d70012dc.jpg";